<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { userModule } from '@/store/user/module'
import UIKit from '@pocketprep/ui-kit'

const {
    Icon,
} = UIKit

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

onMounted(() => {
    setTimeout(() => {
        const titleEl: HTMLElement | null = document.querySelector('.recall-challenge-scoring-loading')
        titleEl?.focus()
    }, 0)
})

</script>

<template>
    <div
        v-dark
        tabindex="-1"
        class="recall-challenge-scoring-loading"
    >
        <img
            v-if="isDarkMode"
            src="@/assets/levelup/dark-mode/recall-challenge-scoring-loading.png"
            alt=""
            class="recall-challenge-scoring-loading__image"
        >
        <img
            v-else
            src="@/assets/levelup/light-mode/recall-challenge-scoring-loading.png"
            alt=""
            class="recall-challenge-scoring-loading__image"
        >
        <div v-dark class="recall-challenge-scoring-loading__title">
            One small step today
        </div>
        <div v-dark class="recall-challenge-scoring-loading__text">
            For one giant leap tomorrow
        </div>
        <Icon
            class="recall-challenge-scoring-loading__loading"
            type="loading2"
            :is-dark-mode="isDarkMode"
        />
    </div>
</template>

<style lang="scss" scoped>
.recall-challenge-scoring-loading {
    outline: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 64px;

    &__image {
        width: 260px;
        height: 260px;
        margin-bottom: 44px;
    }

    &__title {
        color: $brand-black;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        line-height: 25px;
        margin-bottom: 8px;

        &--dark {
            color: $white;
        }
    }

    &__text {
        color: $ash;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 24px;

        &--dark {
            color: $fog;
        }
    }
}
</style>
